import { Routes } from "@angular/router";

export const gestionRoutes: Routes = [
  {
    path: "gestion_inicio",
    loadComponent: () => import("./inicio/gestion.component"),
    data: {
      codmod: "GES",
      icon: "home",
    },
  },
  {
    path: "gestion_vacaciones",
    loadComponent: () => import("./vacaciones/vacaciones.component"),
    data: {
      codmod: "GES",
      icon: "home",
    },
  },
];